import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  routes: [
    //应用入口，最外层路由，由于路由表完全用动态获取，这里需要一个不需要验证权限的默认路由
    {
      path: '/',
      redirect: '/shareWorkTable',
      name: 'layout',
    },
    {
      path: '/shareWorkTable/:type/:params',
      name: 'shareWorksheet',
      component: (resolve) => require(['../views/share/shareWorksheet'],resolve)
    },
    {
      path: '/shareCreateForm/index',
      name: 'shareCreateForm',
      component: (resolve) => require(['../components/shareCreateForm/index'],resolve)
    },
    {
      path: '/info/:projectId/:taskId',
      name: 'taskInfo',
      component: (resolve) => require(['../views/taskInfo'],resolve)
    },
    {
      path: '/serveHall/:companyId/:serviceId',
      name: 'serveHall',
      component: (resolve) => require(['../views/serveHall/serveHall'],resolve)
    },
    {
      path: '/knowledge/',
      name: 'knowledgeList',
      component: (resolve) => require(['../views/knowledge/knowledgeList'],resolve)
    },
    {
      path: '/knowledge/knowledgeDetail/:id',
      name: 'knowledgeDetail',
      component: (resolve) => require(['../views/knowledge/knowledgeDetail'],resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js